import React, { useEffect, useState, useCallback } from 'react';
import DataTable, { createTheme } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { urls } from '../router/urls';
import { themes } from './styles';
import './DistillationDescription.css';

const DistillationDescription = ({ data }) => {
  const { t } = useTranslation();

  //rows de informacion de la destilacion
  const [rows, setRows] = useState([]);

  createTheme('solarized', { themes });

  const table_info = useCallback(() => {
    let aux_info = [];

    data['grouping_resources'].map((elemento, index) => {
      aux_info.push({
        id: index + 1,
        posicion: index + 1,
        titulo: (
          <Link
            className={'a-link'}
            to={`/${urls.recursos}/${elemento['resource_grouped']}`}
          >
            {elemento['title']}
          </Link>
        )
      });
      return null;
    });

    setRows(aux_info);
  }, [data]);

  useEffect(() => {
    table_info();
  }, [table_info]);
  
  return (
    <div className="options">
      <DataTable
        data={rows}
        noHeader={true}
        striped={true}
        theme="solarized"
        columns={[
          {
            name: t('posicion'),
            selector: 'posicion',
            sortable: true
          },
          {
            name: t('titulo'),
            selector: 'titulo',
            sortable: true
          }
        ]}
      />
    </div>
  );
};

export default DistillationDescription;
